import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function ResetPasswordForm({ onSuccess }) {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setMessage("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    const token = searchParams.get("token");
    if (!token) {
      setMessage("Invalid reset link.");
      return;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const data = await response.json();
    if (!response.ok) {
      setMessage(data.error || "Something went wrong.");
      return;
    }

    setMessage(data.message);
    onSuccess?.();
  };

  return (
    <form onSubmit={handleSubmit}>
      {message && <p className="message">{message}</p>}
      <div className="form-field">
        <label className="form-label">New Password</label>
        <input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <div className="form-field">
        <label className="form-label">Confirm Password</label>
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn-auth">Reset password</button>
    </form>
  );
}
